import { render, staticRenderFns } from "./copy-edition-toolbox.vue?vue&type=template&id=7049599a&scoped=true&"
import script from "./copy-edition-toolbox.vue?vue&type=script&lang=ts&"
export * from "./copy-edition-toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./copy-edition-toolbox.vue?vue&type=style&index=0&id=7049599a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049599a",
  null
  
)

export default component.exports